{
  "carrierLabel": "Carrier company",
  "searchPlaceholder": "Search by name",
  "selectAsCarrier": "Select \"{name}\" as Carrier",
  "typeToSearch": "Type to search for a company"
}
